import { ReferentialKey } from 'api/referential';
import { useAppDispatch } from 'app/hooks';
import { GenericViewHeader } from 'back-office/shared/components/GenericViewHeader';
import { SimpleDashboardContent } from 'features/dashboard/DashboardContent';
import { NsKey } from 'enums/NsKey';
import { getMultipleReferentialsByKeys } from 'features/referentials/slices/getMultipleReferentialsByKeysThunk';
import { useDynamicTranslation } from 'hooks/useDynamicTranslation';
import { Building2 } from 'lucide-react';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

export default function PlateformesView() {
  const { t } = useDynamicTranslation([NsKey.Common])
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(getMultipleReferentialsByKeys([
    ]))
  }, [dispatch])

  return (
    <SimpleDashboardContent>
      <GenericViewHeader
        title={t("SIDEBAR.ORGANIZATIONS")}
        icon={Building2}
      />
      <Outlet />
    </SimpleDashboardContent>
  );
}
